import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Button, Spinner } from "react-bootstrap";
import { HiOutlineArrowLeftOnRectangle } from "react-icons/hi2";
import NavigationMenu from "../NavigationMenu/NavigationMenu";
import UserMiniCard from "../../common/UserMiniCard/UserMiniCard";
import LocationBadge from "../../common/Badge/LocationBadge/LocationBadge";
import ManualLocationSelector from "../../common/ManualLocationSelector/ManualLocationSelector";
import Logo from "../../common/Logo/Logo";
import useLogout from "../../../features/auth/hooks/useLogout";
import { useLocation } from "../../../features/location/context/LocationContext";
import "./Sidebar.css";
export default function Sidebar({
  user
}) {
  useLanguage();
  const {
    handleLogout,
    isLoggingOut
  } = useLogout();
  const {
    detectedCity,
    isDetectingLocation
  } = useLocation();
  const resolvedName = user?.name || user?.full_name || user?.fullName || "BaytBuddy User";
  const resolvedEmail = user?.email || "";
  const badgeCity = detectedCity || "";
  return <aside className="bb-sidebar">
      <div className="bb-sidebar__top">
        <div className="bb-sidebar__logo-wrap">
          <Logo />
        </div>

        <LocationBadge city={isDetectingLocation ? "Detecting..." : badgeCity || "Location unavailable"} />


        <ManualLocationSelector />
      </div>

      <div className="bb-sidebar__middle">
        <NavigationMenu />
      </div>

      <div className="bb-sidebar__bottom">
        <UserMiniCard name={resolvedName} email={resolvedEmail} />

        <Button variant="outline-danger" className="bb-sidebar__logout-btn" onClick={() => handleLogout()} disabled={isLoggingOut}>

          {isLoggingOut ? <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />{t("Logging out...")}


          </> : <>
              <HiOutlineArrowLeftOnRectangle className="me-2" />{t("Logout")}

          </>}
        </Button>
      </div>
    </aside>;
}
